module.exports = __webpack_public_path__ + "static/media/backHomeIcon.05156b42.svg";